import epsClient from '../../../api/enrollment-platform-client/api-client'

export async function removeAssignee(applicationPublicKey: string) {
  const response = await epsClient.delete(
    `/benefits/assignee/${applicationPublicKey}`
  )
  return response.data
}
